import { useCallback, useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import {

  checkoutAtencionBotCatalog,

  fetchAtencionBotCatalogSession,

  fetchAtencionBotFrequentProducts

} from '../api/atencionBot';

import BotFarmaciaCatalogPanel from '../components/botFarmacia/BotFarmaciaCatalogPanel';

import '../styles/bot-farmacia-premium.css';



export default function BotFarmaciaCatalogPublic() {

  const { token } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [session, setSession] = useState(null);

  const [frequentProducts, setFrequentProducts] = useState([]);

  const [frequentEnriching, setFrequentEnriching] = useState(false);

  const [adding, setAdding] = useState(false);

  const [done, setDone] = useState(false);



  useEffect(() => {

    let cancelled = false;

    (async () => {

      setLoading(true);

      setError('');

      try {

        const data = await fetchAtencionBotCatalogSession(token);

        if (cancelled) return;



        setSession(data);

        setFrequentProducts(Array.isArray(data?.frequent_products) ? data.frequent_products : []);

        setLoading(false);

        const phone = String(data?.phone || '').trim();

        if (!phone) return;

        const needsList = !(Array.isArray(data?.frequent_products) && data.frequent_products.length);

        const needsPrices = !data?.frequent_prices_enriched;

        if (!needsList && !needsPrices) return;

        setFrequentEnriching(true);

        try {

          if (needsList) {

            const quick = await fetchAtencionBotFrequentProducts(phone, {

              conversationId: data.conversation_id || '',

              dni: data.dni || '',

              quick: true

            });

            if (

              !cancelled &&

              Array.isArray(quick?.frequent_products) &&

              quick.frequent_products.length

            ) {

              setFrequentProducts(quick.frequent_products);

            }

          }

          if (needsPrices) {

            const enriched = await fetchAtencionBotFrequentProducts(phone, {

              conversationId: data.conversation_id || '',

              dni: data.dni || ''

            });

            if (

              !cancelled &&

              Array.isArray(enriched?.frequent_products) &&

              enriched.frequent_products.length

            ) {

              setFrequentProducts(enriched.frequent_products);

            }

          }

        } catch {

          // Catálogo usable; precios pueden quedar en "consultar"

        } finally {

          if (!cancelled) setFrequentEnriching(false);

        }

      } catch (err) {

        if (!cancelled) {

          setError(err?.message || 'Enlace no válido o expirado.');

          setSession(null);

          setFrequentProducts([]);

          setLoading(false);

        }

      }

    })();

    return () => {

      cancelled = true;

    };

  }, [token]);



  const handleClose = useCallback(() => {

    if (session?.conversation_id?.startsWith('local-')) {

      navigate('/bot-farmacia', { replace: true });

      return;

    }

    window.close();

  }, [navigate, session?.conversation_id]);



  const handleAddToCart = useCallback(

    async (selections) => {

      if (!token || !selections?.length || adding) return;

      setAdding(true);

      setError('');

      try {

        const data = await checkoutAtencionBotCatalog(token, selections);

        if (data?.is_simulation && data.conversation_id) {

          sessionStorage.setItem('bf_catalog_refresh', data.conversation_id);

          navigate('/bot-farmacia', { replace: true });

          return;

        }

        setDone(true);

      } catch (err) {

        setError(err?.message || 'No se pudo agregar al carrito.');

      } finally {

        setAdding(false);

      }

    },

    [adding, navigate, token]

  );



  if (loading) {

    return (

      <section className="crm-bf-catalog-page crm-bf-catalog-page--public crm-bf-catalog-page--loading">

        <div className="crm-bf-catalog-public-state crm-bf-catalog-public-state--loading" role="status" aria-live="polite">

          <div className="crm-bf-catalog-public-spinner" aria-hidden="true" />

          <p className="crm-bf-catalog-public-state__title">Verificando enlace seguro…</p>

        </div>

      </section>

    );

  }



  if (error && !session) {

    return (

      <section className="crm-bf-catalog-page crm-bf-catalog-page--public">

        <div className="crm-bf-catalog-public-state crm-bf-catalog-public-state--error">

          <span aria-hidden="true">🔒</span>

          <h1>Enlace no disponible</h1>

          <p>{error}</p>

          <p className="crm-bf-catalog-public-state__hint">

            El catálogo personal vence a los 20 minutos y solo funciona para el cliente al que se lo envió Anita.

          </p>

        </div>

      </section>

    );

  }



  if (done) {

    return (

      <section className="crm-bf-catalog-page crm-bf-catalog-page--public">

        <div className="crm-bf-catalog-public-state crm-bf-catalog-public-state--success">

          <span aria-hidden="true">✓</span>

          <h1>¡Listo!</h1>

          <p>Tu selección fue enviada a Anita.</p>

          <p className="crm-bf-catalog-public-state__hint">

            Volvé a WhatsApp para continuar la conversación.

          </p>

        </div>

      </section>

    );

  }



  return (

    <section className="crm-bf-catalog-page crm-bf-catalog-page--public">

      {adding ? (
        <div
          className="crm-bf-catalog-checkout-overlay"
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <div className="crm-bf-catalog-checkout-overlay__card">
            <div className="crm-bf-catalog-public-spinner" aria-hidden="true" />
            <p className="crm-bf-catalog-checkout-overlay__title">Agregando al carrito…</p>
            <p className="crm-bf-catalog-checkout-overlay__hint">Enviando tu selección a Anita</p>
          </div>
        </div>
      ) : null}

      <BotFarmaciaCatalogPanel

        initialHits={session?.hits || []}

        initialFrequent={frequentProducts}

        frequentEnriching={frequentEnriching}

        contactLabel={session?.contact_hint ? `sesión ${session.contact_hint}` : ''}

        expiresInSeconds={session?.expires_in_seconds}

        onSessionExpired={() => {
          setError('El enlace expiró. Volvé al chat y pedile a Anita un nuevo catálogo.');
        }}

        onClose={handleClose}

        onAddToCart={handleAddToCart}

        adding={adding}

      />

      {error ? (

        <p className="crm-bf-catalog-public-error" role="alert">

          {error}

        </p>

      ) : null}

    </section>

  );

}


